module.exports = __webpack_public_path__ + "static/media/bakri-instructions-for-use@2x.254b1a79.jpg";